/* eslint-disable complexity */
import type {ActionType} from 'constants/flow/flowTypes';
import type {QuoteItemsType} from 'constants/flow/flowTypesCart';
import {COUPON, QUOTE_ITEM, CART, CHECKOUT} from 'constants/actions';
import {PRODUCT_TYPES} from 'constants/product';
import {getItemsCount} from 'actions/cart/cart';

export const initialState = {
    status: '',
    pending: false,
    count: 0,
    messages: [],
    quoteItems: [],
    totals: {
        appliedCoupons: [],
        currency: '$',
        tax: '0',
        copay: '0',
        subtotal: '',
        total: '',
        shippingPrice: '',
        shippingMethod: '',
        discount: '',
        discountWithoutShippingDiscount: '',
        shippingDiscount: '',
    },
};

/**
 * Converts prescription values contains null to "None"
 * @param {QuoteItemsType} items  quoteItems from data of response fetchQuoteItemV2
 * @returns {QuoteItemsType} items with prescription contains values with "None" instead null
 */
export const checkPrescriptionValuesOnNull = (items: QuoteItemsType) =>
    items?.map(item => {
        if (item?.prescription && item.type === PRODUCT_TYPES.EYEGLASSES) {
            const prescription = {...item?.prescription};

            const changeValuesToNone = object => {
                Object.keys(object).forEach(key => {
                    if (object[key] === null) {
                        // eslint-disable-next-line no-param-reassign
                        object[key] = 'None';
                    }
                    if (typeof object[key] === 'object') {
                        changeValuesToNone(object[key]);
                    }
                });
            };

            changeValuesToNone(prescription);

            return {...item, prescription};
        }
        return item;
    }) || [];

/**
 * Items in cart
 * @param {state} state Current state
 * @param {ActionType<QuoteItemsType>} action Received action
 * @returns {QuoteItemsType} Order review data
 */
export default function quoteItems(
    state: QuoteItemsType = initialState,
    action: ActionType<QuoteItemsType>,
): QuoteItemsType {
    switch (action.type) {
        case `${QUOTE_ITEM.GET_ITEMS}_FULFILLED`:
            return {
                status: 'fulfilled',
                ...action.payload.data,
                quoteItems: checkPrescriptionValuesOnNull(action.payload.data.quoteItems),
                pending: false,
            };
        case `${CART.ADD_UPSELL_ITEM}_FULFILLED`:
        case `${CART.REMOVE_UPSELL_ITEM}_FULFILLED`:
            return {status: 'fulfilled', ...action.payload.data, pending: false};
        case `${COUPON.ADD_COUPON}_FULFILLED`:
        case `${COUPON.REMOVE_COUPON}_FULFILLED`:
            return {
                ...state,
                status: 'fulfilled',
                totals: {...action.payload.data},
                pending: false,
            };
        case `${QUOTE_ITEM.GET_ITEMS}_PENDING`:
            return {...state, status: '', pending: true};
        case CHECKOUT.SAVE_ORDER_SUCCESS:
            // Leave fields which uses for success page analytics.
            return {
                ...initialState,
                totals: state.totals,
                count: state.count,
                quoteItems: state.quoteItems,
            };
        case `${getItemsCount}_FULFILLED`:
            return {...state, count: action.payload.data.count};
        case `${CART.ADD_TO_CART}_FULFILLED`:
            return {...state, status: ''};
        default:
            return state;
    }
}
